import { h, JSX } from "@stencil/core";
import { isString, isModelName } from "@phn/utility/helper";

export default function SideDrawerItemText({
  isActive,
  text,
  subtext,
  renderSignatures,
  size = "inherit",
}: {
  isActive: boolean;
  text: string;
  subtext: string;
  renderSignatures: boolean;
  size?: string;
}): JSX.Element {
  return (
    <div class="text-container">
      {renderSignatures && isModelName(text) ? (
        <phn-p-model-signature
          model={text.toLowerCase()}
          size="inherit"
          class="model-signature"
        />
      ) : (
        <phn-p-text
          size={size}
          weight={isActive ? "semibold" : "regular"}
          color="inherit"
          tag="div"
          ellipsis="true"
        >
          {text}
        </phn-p-text>
      )}

      {isString(subtext) ? (
        <div class="fs-mask" data-cs-mask>
          <phn-p-text
            color="contrast-medium"
            class="subtext"
            weight="regular"
            size="x-small"
            tag="div"
            ellipsis="true"
            data-test-id="subtext"
          >
            {subtext}
          </phn-p-text>
        </div>
      ) : null}
    </div>
  );
}
